/**
 * W-8 纯逻辑(便于单测):分状态桶序 + 行操作态可见性矩阵。
 * 真源 App SellerProductsPage.tsx:42-103 / SellerProductRow.tsx:156-186。
 */
import type { ProductStatus, SellerProductListItem } from '@/api/products';
import { STATUS_ORDER } from '@/lib/productLabels';

export interface ProductGroup {
  status: ProductStatus;
  items: SellerProductListItem[];
}

/** 按 STATUS_ORDER 分组,空组省略,组内保持后端原序。 */
export function groupByStatus(items: SellerProductListItem[]): ProductGroup[] {
  return STATUS_ORDER.map((status) => ({
    status,
    items: items.filter((i) => i.status === status),
  })).filter((g) => g.items.length > 0);
}

export interface RowActions {
  /** 编辑按钮是否渲染(每行都渲染)。 */
  showEdit: true;
  /** 编辑是否禁用(PENDING_AUDIT「审核中无法编辑」)。 */
  editDisabled: boolean;
  /** 编辑是否主按钮(REJECTED 时 primary)。 */
  editPrimary: boolean;
  /** 下架(仅 ONLINE)。 */
  showOffline: boolean;
  /** 重新上架(仅 OFFLINE)。 */
  showRepublish: boolean;
  /** 驳回原因卡(仅 REJECTED)。 */
  showRejection: boolean;
}

export function rowActions(status: ProductStatus): RowActions {
  return {
    showEdit: true,
    editDisabled: status === 'PENDING_AUDIT',
    editPrimary: status === 'REJECTED',
    showOffline: status === 'ONLINE',
    showRepublish: status === 'OFFLINE',
    showRejection: status === 'REJECTED',
  };
}

/** 驳回原因预览截断(80 字 + …),同 App REJECTION_REASON_PREVIEW_LEN。 */
export const REJECTION_PREVIEW_LEN = 80;
export function previewRejection(reason: string | null | undefined): string {
  if (!reason) return '';
  const cp = [...reason];
  return cp.length > REJECTION_PREVIEW_LEN ? `${cp.slice(0, REJECTION_PREVIEW_LEN).join('')}…` : reason;
}
